import {ParagraphNode, LexicalNode, EditorConfig, LexicalEditor} from 'lexical';
import {isRTL} from '../../../../Localization';
import {defaultStyles} from '../../constants';

export class StyledParagraphNode extends ParagraphNode {
    static getType(): string {
        return 'styled-paragraph';
    }

    static clone(node: StyledParagraphNode): StyledParagraphNode {
        return new StyledParagraphNode(node.__key);
    }

    static importJSON(serializedNode: any): StyledParagraphNode {
        const node = $createStyledParagraphNode();
        node.setFormat(serializedNode.format);
        node.setIndent(serializedNode.indent);
        node.setDirection(serializedNode.direction);
        return node;
    }

    createDOM(config: EditorConfig): HTMLElement {
        const dom = super.createDOM(config);

        // Apply default styles only if not already present
        if (!dom.style.fontSize) {
            dom.style.fontSize = `${defaultStyles.fontSize}px`;
        }
        if (!dom.style.fontFamily) {
            dom.style.fontFamily = defaultStyles.fontFamily;
        }

        // Dynamic RTL detection based on content
        this.setDefaultDirection(dom);

        return dom;
    }

    updateDOM(prevNode: StyledParagraphNode, dom: HTMLElement, config: EditorConfig): boolean {
        const result = super.updateDOM(prevNode, dom, config);

        // Update direction when content changes
        this.setDefaultDirection(dom);

        return result;
    }

    private setDefaultDirection(dom: HTMLElement): void {
        const textContent = dom.textContent || '';

        if (!textContent.trim()) {
            dom.setAttribute('dir', isRTL() ? 'rtl' : 'ltr');
        }
    }

    exportDOM(editor: LexicalEditor) {
        const {element} = super.exportDOM(editor);

        return {element};
    }

    exportJSON(): any {
        return {
            ...super.exportJSON(),
            type: 'styled-paragraph',
            version: 1
        };
    }

    isSimple(): boolean {
        return true;
    }
}

export function $createStyledParagraphNode(): StyledParagraphNode {
    return new StyledParagraphNode();
}

export function $isStyledParagraphNode(
    node: LexicalNode | null | undefined
): node is StyledParagraphNode {
    return node instanceof StyledParagraphNode;
}

export const setDefaultParagraphStyles = (node: ParagraphNode) => {
    const styledNode = $createStyledParagraphNode();
    const format = node.getFormatType();
    const indent = node.getIndent();
    const direction = node.getDirection();

    // Only set properties if they have valid values
    if (format) styledNode.setFormat(format);
    if (indent) styledNode.setIndent(indent);
    if (direction) styledNode.setDirection(direction);

    return styledNode;
};

// Node transformation to replace default paragraph nodes with styled ones
export function transformParagraphNodes() {
    return {
        paragraph: setDefaultParagraphStyles
    };
}
